export default "__VITE_ASSET__B0OR8vVo__"